// ABOUTME: Pure FPS sampler for the demo on-screen meter — no DOM, no globals.
// ABOUTME: Fed rAF timestamps each frame; reports a rounded FPS once per window.

// createFpsSampler({ intervalMs }) → { sample(nowMs), get fps }
// sample() returns a fresh FPS number when a window closes, else null. The first
// call only primes the window start. `.fps` holds the last reported value.
export function createFpsSampler({ intervalMs = 500 } = {}) {
    let frames = 0;
    let windowStart = null;
    let lastFps = 0;
    return {
        sample(nowMs) {
            if (windowStart === null) {
                windowStart = nowMs;
                return null;
            }
            frames++;
            const elapsed = nowMs - windowStart;
            if (elapsed >= intervalMs) {
                lastFps = Math.round((frames * 1000) / elapsed);
                frames = 0;
                windowStart = nowMs;
                return lastFps;
            }
            return null;
        },
        get fps() {
            return lastFps;
        },
    };
}
